import { Field, Formik, FormikHelpers, FormikProps } from "formik"
import { Form, SubmitButton, TextField } from "formik-material-ui-elements"
import React, { ReactNode } from "react"
import * as yup from "yup"
import styled from "styled-components"

const validationSchema = yup.object().shape({
  code: yup.string().required("Required"),
})

export interface FormValues {
  code: string
}

const LoginButton = styled(SubmitButton)`
  margin:auto;
  border-radius: 8px;
`

interface Props {
  onSubmit: (
    values: FormValues,
    actions: FormikHelpers<FormValues>,
  ) => void | Promise<any>
  initialValues?: FormValues
}

const defaultValues = {
  code: "",
}

const ConfirmSignInForm: React.FC<Props> = ({
  onSubmit,
  initialValues = defaultValues,
}: Props) => (
  <Formik
    initialValues={initialValues}
    validateOnBlur={false}
    validationSchema={validationSchema}
    onSubmit={onSubmit}
  >
    {({ isSubmitting }: FormikProps<FormValues>): ReactNode => (
      <Form noValidate>
        <Field
          autoFocus
          component={TextField}
          id="code"
          label="Verification Code"
          name="code"
          size="small"
          color="secondary"
          required
        />
        <LoginButton
          color="secondary"
          variant="contained"
          fullWidth
          loading={isSubmitting}
          disabled={isSubmitting}
        >
          Confirm
        </LoginButton>
      </Form>
    )}
  </Formik>
)

export default ConfirmSignInForm
